import './scss/_style.scss';
import 'jquery-ui-dist/jquery-ui.css';
import { __ } from '@wordpress/i18n';

import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.standalone.css';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.de.min.js';

jQuery( '.connectoor-jobs-filters input.connectoor_jobs_begin_datepicker' ).datepicker( {
	format: "dd.mm.yyyy",
	startDate: "now",
	language: "de"
} );


//Connectoor Jobs Plugin - Klickbare Index li-Container
document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( 'ul.wp-block-post-template.branding-color li' ).forEach( li => {
		li.addEventListener( 'click', e => {
			if ( e.target.tagName !== 'a' ) {
				window.location.href = li.querySelector( 'a' ).href;
			}
		} );

		const jobMetaFields = li.querySelectorAll( '.job-meta .wp-block-connectoor-jobs-meta-field' );
		if ( jobMetaFields.length === 0 ) {
			return;
		}

		const lastField = jobMetaFields[ jobMetaFields.length - 1 ];

		// Extrahiere das Datum aus dem letzten Feld
		const dateText = lastField.textContent.trim();
		const [ day, month, year ] = dateText.split( '.' ).map( Number );
		const jobDate = new Date( year, month - 1, day ); // JavaScript Monate sind 0-indexiert

		// Heutiges Datum (ohne Uhrzeit)
		const today = new Date();
		today.setHours( 0, 0, 0, 0 ); // Entfernt Uhrzeit für Vergleich

		// Prüfe, ob das Datum heute oder in der Vergangenheit liegt
		if ( jobDate <= today ) {
			lastField.textContent = __( 'now', 'connectoor-jobs-pro' );
		}
	} );

	document.querySelectorAll('.connectoor-jobs-meta-wrapper .filter-group select')
		.forEach(function(sel){
			var group = sel.closest('.filter-group');
			if (!group) return;
			if (!group.classList.contains('select-shell')) {
				group.classList.add('select-shell');
			}
			var span = group.querySelector('.value');
			if (!span) {
				span = document.createElement('span');
				span.className = 'value';
				span.setAttribute('aria-hidden','true');
				group.appendChild(span);
			}
			function sync(){
				var opt = sel.options[sel.selectedIndex];
				span.textContent = opt ? opt.text : '';
			}
			sel.addEventListener('change', sync);
			sync();
		});
} );


jQuery( document ).ready( function ( $ ) {

	var $btn   = $('.toggle-filters');
	var $panel = $('.connectoor-jobs-filters'); // dein bestehendes Panel

	function syncUI() {
		var visible = $panel.is(':visible');
		$btn.attr('aria-expanded', visible ? 'true' : 'false')
			.text( visible ? $btn.data('text-close') : $btn.data('text-open') );

		// optional für A11y:
		if (visible) { $panel.removeAttr('hidden'); }
		else { $panel.attr('hidden', ''); }
	}

	// Initialen Zustand synchronisieren (falls Panel per CSS/Server schon sichtbar/hidden ist)
	syncUI();

	// Toggle + Label-Wechsel
	$(document).on('click', '.toggle-filters', function(){
		$panel.toggle();
		syncUI();
	});

	const $input = $( '#connectoor-job-search' );
	const defaultPerPage = 10;

	if ( $input.length < 1 ) return;

	let suppressNextChange = false;
	$input.autocomplete( {
		source: function ( request, response ) {
			$.ajax( {
				url: searchVars.ajaxUrl,
				dataType: 'json',
				data: {
					action: 'connectoor_jobs_search_jobs',
					q: request.term,
					categories: searchVars.categoriesTerms,
					nonce: searchVars.nonce
				},
				success: function ( data ) {
					const seenTitles = new Set();

					const uniqueSuggestions = data.results.filter( post => {
						if ( seenTitles.has( post.post_title ) ) {
							return false;
						}
						seenTitles.add( post.post_title );
						return true;
					} ).map( post => ( {
						label: post.post_title,
						value: post.post_title,
						postId: post.ID
					} ) );

					response( uniqueSuggestions );
				}
			} );
		},
		minLength: 2,
		select: function ( event, ui ) {
			// Auswahl wurde getroffen (text bleibt im Feld)
			suppressNextChange = true;
			const searchTerm = ui.item.value;
			$input.val(searchTerm);
			// Ergebnisse rendern
			loadJobResults( searchTerm, 1, defaultPerPage );
		}
	} );

	// Alternativ auch bei Enter oder Input-Änderung suchen
	$input.on( 'change keyup', function ( e ) {
		if (suppressNextChange) {
			suppressNextChange = false;          // genau einen change/keyup schlucken
			return;
		}
		if ( e.keyCode === 13 || $input.val().length >= 3 ) {
			loadJobResults( $input.val(), 1, defaultPerPage );
		}
	} );

	let currentRequest = null;

	// Ajax-Suchergebnisse laden
	function loadJobResults( searchTerm, page = 1, perPage = 10 ) {

		if ( currentRequest !== null ) {
			currentRequest.abort();
		}
		const container = $( '.wp-block-query' );
		container.empty();

		const postal_or_city = $( '#postal_or_city' ).val();
		const radius = $( '#radius' ).val();
		const homeoffice = $( '#homeoffice' ).is( ':checked' ) ? '1' : '0';
		const jobJobtype = $( '#job_jobtype' ).val();
		const country = $( '#country' ).val();
		const company = $( '#job_company' ).val();
		const expierence = $( '#job_experience' ).val();
		const duration = $( '#job_emp_duration' ).val();

		const jobCategory = $('.job_category:checked').map(function () { return this.value; }).get(); // → Array
		const empTypes = $('.emp_type:checked').map(function () { return this.value; }).get(); // → Array

		// Neuen Raw-Timestamp erzeugen:
		let begin_raw = 0;
		const begin = $( '.connectoor_jobs_begin_datepicker' ).val();
		if ( begin ) {
			const parts = begin.split( '.' );
			if ( parts.length === 3 ) {
				const dateObj = new Date( parts[ 2 ], parts[ 1 ] - 1, parts[ 0 ] );
				begin_raw = Math.floor( dateObj.getTime() / 1000 );
			}
		}

		$.ajax( {
			url: searchVars.ajaxUrl,
			dataType: 'json',
			method: 'GET',
			data: {
				action: 'connectoor_jobs_search_jobs',
				q: searchTerm,
				nonce: searchVars.nonce,
				categories: searchVars.categoriesTerms,
				postal_or_city: postal_or_city,
				radius: radius,
				homeoffice: homeoffice,
				'job_category[]': jobCategory,
				'emp_type[]': empTypes,
				job_jobtype: jobJobtype,
				job_company: company,
				job_experience: expierence,
				job_emp_duration: duration,
				country: country,
				begin_raw: begin_raw,
				page: page,
				per_page: perPage,
				page_id: searchVars.page_id,
			},
			success: function ( data ) {
				currentRequest = null; // Reset if successfull.
				const counter = $( '.connectoor-search-results-count' );

				// check if jobs were found or not and change text accordingly.
				if ( data.results.length === 0 ) {
					counter.text(  __( 'No jobs found.', 'connectoor-jobs-pro' ) );
					return;
				} else {
					counter.text( data.total_found + ' ' + ( data.total_found === 1 ? __( 'Job found.', 'connectoor-jobs-pro' ) : __( 'Jobs found.', 'connectoor-jobs-pro' ) ) );
				}

				const ul = $( '<ul class="branding-color wp-block-post-template"></ul>' );

				data.results.forEach( function ( post ) {
					const li = $( `<li class="connectoor_jobs">${ post.html }</li>` );
					ul.append( li );
				} );

				container.append( ul );

				// Include pagination in gutenberg style.
				renderPagination( container, data.max_pages, data.paged );

				// Make li clickable.
				$( document ).on( 'click', 'ul.branding-color li.connectoor_jobs', function ( e ) {
					if ( e.target.tagName.toLowerCase() !== 'a' ) {
						window.location.href = $( this ).find( 'a' ).attr( 'href' );
					}
				} );


			},
			error: function () {
				currentRequest = null; // Rest if error.
			}
		} );
	}


	// Live-filter at change of any filter field
	$( '#postal_or_city, #radius, #homeoffice, .job_category, .emp_type, #job_jobtype,#job_experience,#job_emp_duration,#job_company, #country, .connectoor_jobs_begin_datepicker' )
		.off('change.filters')
		.on('change.filters', function () {
		const searchTerm = $( '#connectoor-job-search' ).val();
		loadJobResults( searchTerm, 1, defaultPerPage );
	} );

	// Reset buton handler.
	jQuery(function($){
		// Change listener: only on real filter fields (without reset button).
		$( '#postal_or_city, #radius, #homeoffice, .job_category, .emp_type, #job_jobtype,#job_experience,#job_emp_duration,#job_company, #country, .connectoor_jobs_begin_datepicker' )
			.off('change.filters')
			.on('change.filters', function () {
				if (window.__filters_silent) return; // ignoer while resetting.
				const searchTerm = $('#connectoor-job-search').val();
				loadJobResults(searchTerm, 1, 10);
			});

		$(document).on('keydown.filters change.filters', '.job_category, .emp_type', function (e) {
			if (window.__filters_silent) return;

			if (e.type === 'change' || e.key === ' ' || e.key === 'Enter') {
				const searchTerm = $('#connectoor-job-search').val();
				loadJobResults(searchTerm, 1, 10);
			}
		});


		// Reset Handler (Button first element in wrapper)
		$(document)
			.off('click.filtersReset')
			.on('click.filtersReset', '.connectoor-jobs-filters .reset-filter', function (e) {
				e.preventDefault();

				const $wrap = $(this).closest('.connectoor-jobs-filters');
				if (!$wrap.length) return;

				// All Events that could trigger "change" are muted briefly
				window.__filters_silent = true;

				// clear text inputs (incl. datepicker)
				$wrap.find('input[type="text"]').val('');
				$wrap.find('.connectoor_jobs_begin_datepicker').each(function () {
					try { $(this).datepicker('update', ''); } catch (e) { $(this).val(''); }
				});

				$wrap.find('#homeoffice').prop('checked', false);

				$wrap.find('div.multiselect-container').each(function () {
					$(this).find('input[type="checkbox"]').prop('checked', false);
					$(this).find('label[role="option"]').attr('aria-selected', 'false');

					const reset_btn_text = $(this)
						.siblings('label.screen-reader-text')
						.text()
						.trim();

					const $btn = $(this).find('.multiselect-btn');
					$btn.find('.label').text(reset_btn_text);
				});

				$wrap.find('select').each(function () {
					this.selectedIndex = 0;
					this.nextElementSibling.textContent = this.options[0] ? this.options[0].text : '';
				});

				window.__filters_silent = false;

				const searchTerm = $('#connectoor-job-search').val();
				loadJobResults(searchTerm, 1, 10);
			});
	});


	function renderPagination( container, maxPages, currentPage ) {
		// Remove old pagination
		container.find( '.wp-block-query-pagination' ).remove();
		if ( maxPages < 2 ) return;

		const nav = $( `
    <nav class="wp-block-query-pagination is-layout-flex wp-block-query-pagination-is-layout-flex"
         role="navigation" aria-label="Seitennummerierung"></nav>
  ` );

		//  Previous Link only append if currentPage > 1
		if ( currentPage > 1 ) {
			const prevPage = currentPage - 1;
			nav.append( `
      <a href="?query-1-page=${ prevPage }"
         class="wp-block-query-pagination-previous"
         aria-label="Vorherige Seite">
        Vorherige Seite
      </a>
    ` );
		}

		// Number Container
		const numbers = $( `<div class="wp-block-query-pagination-numbers"></div>` );
		const total = maxPages;
		const delta = 2;
		let range = [];
		for ( let i = 1; i <= total; i++ ) {
			if (
				i === 1 ||
				i === total ||
				( i >= currentPage - delta && i <= currentPage + delta )
			) {
				range.push( i );
			}
		}

		let last = 0;
		range.forEach( i => {
			if ( last + 1 < i ) {
				// Dots with own element and spacer.
				numbers.append( '<span class="page-numbers dots">…</span>&nbsp;' );
			}
			if ( i === currentPage ) {
				numbers.append( `<span aria-current="page" class="page-numbers current">${ i }</span>&nbsp;` );
			} else {
				numbers.append( `<a class="page-numbers" href="?query-1-page=${ i }">${ i }</a>&nbsp;` );
			}
			last = i;
		} );

		nav.append( numbers );

		// Next Link only append if not last page
		if ( currentPage < total ) {
			const nextPage = currentPage + 1;
			nav.append( `
      <a href="?query-1-page=${ nextPage }"
         class="wp-block-query-pagination-next"
         aria-label="Nächste Seite">
        Nächste Seite
      </a>
    ` );
		}

		container.append( nav );

		// Click-Handler
		container
			.find( '.wp-block-query-pagination-previous, .page-numbers[href], .wp-block-query-pagination-next' )
			.off( 'click' )
			.on( 'click', function ( e ) {
				e.preventDefault();
				const href = $( this ).attr( 'href' );
				const page = href.match( /query-1-page=(\d+)/ )
					? parseInt( href.match( /query-1-page=(\d+)/ )[ 1 ], 10 )
					: 1;
				loadJobResults( $( '#connectoor-job-search' ).val(), page, defaultPerPage );
			} );
	}
} );


function initMultiselect(id) {
	const container = document.getElementById(id);
	if (!container) return;

	const btn = container.querySelector('.multiselect-btn');
	const options = container.querySelector('.multiselect-options');
	const label = btn.querySelector('.label');
	const optionLabels = options.querySelectorAll('label');
	const checkboxes = options.querySelectorAll('input[type="checkbox"]');

	if (!btn || !options || !label) return;

	// toggle dropdown.
	const toggleDropdown = () => {
		container.classList.toggle('open');
		btn.setAttribute('aria-expanded', container.classList.contains('open'));
		if (container.classList.contains('open')) {
			optionLabels[0]?.focus();
		}
	};

	// close dropdown.
	const closeDropdown = () => {
		container.classList.remove('open');
		btn.setAttribute('aria-expanded', 'false');
	};

	const updateLabel = () => {
		const selected = [...checkboxes]
			.filter(cb => cb.checked)
			.map(cb => (cb.closest('label') || cb.parentNode).textContent.trim());

		label.textContent = selected.length ? selected.join(', ') : (btn.dataset.placeholder || 'nicht filtern');

		optionLabels.forEach(lab => {
			const cb = lab.querySelector('input[type="checkbox"]');
			lab.setAttribute('aria-selected', cb.checked ? 'true' : 'false');
		});
	};

	btn.addEventListener('click', e => {
		e.stopPropagation();
		toggleDropdown();
	});

	btn.addEventListener('keydown', e => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			toggleDropdown();
		} else if (e.key === 'Escape') {
			closeDropdown();
			btn.focus();
		}
	});

	checkboxes.forEach(cb => cb.addEventListener('change', updateLabel));

	optionLabels.forEach((lab, idx) => {
		lab.addEventListener('keydown', e => {
			let newIndex;
			if (e.key === 'ArrowDown') {
				e.preventDefault();
				newIndex = (idx + 1) % optionLabels.length;
				optionLabels[newIndex].focus();
			} else if (e.key === 'ArrowUp') {
				e.preventDefault();
				newIndex = (idx - 1 + optionLabels.length) % optionLabels.length;
				optionLabels[newIndex].focus();
			} else if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				const cb = lab.querySelector('input[type="checkbox"]');
				cb.checked = !cb.checked;
				updateLabel();
				cb.dispatchEvent(new Event('change', { bubbles: true }));
			} else if (e.key === 'Escape') {
				closeDropdown();
				btn.focus();
			}
		});
	});

	// click outside closes dropdown
	document.addEventListener('click', e => {
		if (!container.contains(e.target)) {
			closeDropdown();
		}
	});

	// lost  focus closes dropdown (Tab outside)
	container.addEventListener('focusout', e => {
		setTimeout(() => {
			if (!container.contains(document.activeElement)) {
				closeDropdown();
			}
		}, 0);
	});
}

['jobkategorie-container','berufsart-container'].forEach(initMultiselect);

addEventListener('click', e => {
	const g = e.target.closest('.filter-group.homeoffice');
	if (!g) return;

	const c = g.querySelector('input[type="checkbox"]');
	if (!c || c.disabled) return;

	const l = c.closest('label');
	if (e.target === c || (l && l.contains(e.target))) return; // native Toggle zulassen

	c.checked = !c.checked;
	c.dispatchEvent(new Event('change', { bubbles: true }));
});
